<script setup lang="ts">
import { Home, Inbox, ShieldCheck, Users } from 'lucide-vue-next';
import { useFamily } from '@/composables/useFamily';
import { useNavigation } from '@/composables/useNavigation';

const { navigate, route } = useNavigation();
const { setMailboxViewer } = useFamily();

const items = [
  { key: 'family', label: 'Familie', icon: Home },
  { key: 'child-home', label: 'Kind', icon: Users },
  { key: 'mailbox', label: 'Briefe', icon: Inbox },
  { key: 'parent-settings', label: 'Eltern', icon: ShieldCheck }
] as const;

function openNavigationItem(key: (typeof items)[number]['key']) {
  if (key === 'mailbox') {
    setMailboxViewer(route.value === 'child-home' || route.value === 'friend' || route.value === 'drawing' || route.value === 'voice' ? 'child' : 'parent');
  }

  navigate(key);
}
</script>

<template>
  <nav class="fixed inset-x-0 bottom-0 z-20 border-t border-orange-100 bg-white/95 px-2 py-2 shadow-soft backdrop-blur md:hidden">
    <div class="mx-auto grid max-w-lg grid-cols-4 gap-1">
      <button
        v-for="item in items"
        :key="item.key"
        class="focus-ring flex min-h-16 flex-col items-center justify-center gap-1 rounded-2xl text-xs font-black"
        :class="route === item.key ? 'bg-heart-coral text-white' : 'text-heart-ink'"
        type="button"
        :aria-label="item.label"
        @click="openNavigationItem(item.key)"
      >
        <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
        {{ item.label }}
      </button>
    </div>
  </nav>
</template>
